const isAndroid = () => !/iPad|iPhone|iPod|Mac/.test(navigator.userAgent);

export const openStore = () => {
  const storeLink = isAndroid() ?
    "https://play.google.com/store/apps/details?id=com.goodvets" :
    "https://apps.apple.com/us/app/goodvets/id6450904906";

  window.open("https://goodvets.app.link");
  setTimeout(() => {
    window.open(storeLink, "_blank");
  }, 1000);
};
